import { xhrFetch } from "@origin-digital/daxi";
import { logger } from "@origin-digital/reporting-client";
import { formatQueryParameters, getHostName } from "../helpers/url.helper";
import { CustomerContext } from "../../../shared/interface/navigation";
import { IAppContext } from "../AppContext";

const path = "/api/widget/v1/hello";

interface IHelloRequestParams {
  internal: boolean;
  url: string;
  kb: string;
  context?: string;
  visitorToken?: string;
}

const helloApiUrl = (params: IHelloRequestParams, host: string): string => {
  const queryParams = formatQueryParameters<IHelloRequestParams>(params);
  const url = `${host}${path}?${queryParams}`;
  return encodeURI(url);
};

export const newSessionId = async (
  host: string,
  kb: string,
  context?: CustomerContext,
  visitorToken?: string
): Promise<IAppContext["session"]["data"]> => {
  try {
    const params: IHelloRequestParams = {
      kb,
      internal: true,
      url: `${getHostName()}/`,
      context: context && `customer:${context}`,
      visitorToken,
    };
    const { data } = await xhrFetch<IAppContext["session"]["data"]>(
      helloApiUrl(params, host),
      { includeCommonHeaders: false }
    );
    return data;
  } catch (error) {
    logger.error("error fetching session id for search", error);
  }
  return undefined;
};
